import { create } from "zustand";

export type ToastKind = "success" | "error" | "info";

export interface Toast {
  id: string;
  text: string;
  kind: ToastKind;
}

interface ToastState {
  toasts: Toast[];
  push(text: string, kind?: ToastKind): void;
  dismiss(id: string): void;
}

// Лёгкие тосты для feedback быстрых действий (Command Palette и т.п.).
export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (text, kind = "success") => {
    const id = Math.random().toString(36).slice(2);
    set((state) => ({ toasts: [...state.toasts, { id, text, kind }] }));
    if (typeof window !== "undefined") {
      window.setTimeout(() => {
        set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
      }, 3200);
    }
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }))
}));

/** Императивный помощник — вызывать из обработчиков без хука. */
export const pushToast = (text: string, kind: ToastKind = "success"): void =>
  useToasts.getState().push(text, kind);
